import { render, staticRenderFns } from "./ScrollTable.vue?vue&type=template&id=214ce0e3&"
import script from "./ScrollTable.vue?vue&type=script&lang=js&"
export * from "./ScrollTable.vue?vue&type=script&lang=js&"
import style0 from "./ScrollTable.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports